import React, { useEffect, useState } from 'react';
import { useConsultationForm } from './ConsultationFormContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    openForm
  } = useConsultationForm();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-warm-bg/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} style={{
    maxHeight: '60px',
    display: 'flex',
    alignItems: 'center'
  }} data-id="element-145">
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-between w-full" data-id="element-146">
        <a href="#" className="z-50 relative" data-id="element-147">
          <img src="https://cdn.magicpatterns.com/uploads/5RNjZoEyFX9YxjeYhDUbc2/Be_Clinical_logo_navy_hex.png" alt="Be Clinical" className="h-12 w-auto" data-id="element-148" />
        </a>

        <button onClick={openForm} className="bg-gold hover:bg-[#A6844E] text-white font-bold uppercase tracking-wider px-6 py-2.5 rounded-sm transition-all duration-300 text-xs" data-id="element-149">
          Book Now
        </button>
      </div>
    </header>;
}